var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.TheSection,
    {
      staticClass: "flex flex-col projects",
      attrs: { legend: "Won battles", id: "battles" },
    },
    _vm._l(_setup.projects, function (project, index) {
      return _c(_setup.ProjectCover, {
        key: project.id,
        attrs: { reverse: index % 2 !== 0, project: project },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }